import { watchEffect, unref } from 'vue'

function setMeta (selector, attr, key, value) {
  let el = document.head.querySelector(selector)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', value)
}

/** Applies a document title and description (also mirrored to Open Graph). */
export function applyPageMeta ({ title, description }) {
  // No document while prerendering; the build script writes the head tags.
  if (typeof document === 'undefined') {
    return
  }
  if (title) {
    document.title = title
    setMeta('meta[property="og:title"]', 'property', 'og:title', title)
  }
  if (description) {
    setMeta('meta[name="description"]', 'name', 'description', description)
    setMeta('meta[property="og:description"]', 'property', 'og:description', description)
  }
}

/** Adds or removes <meta name="robots" content="noindex, follow"> in the browser. */
export function applyRobots (noindex) {
  if (typeof document === 'undefined') {
    return
  }
  const existing = document.head.querySelector('meta[name="robots"]')
  if (noindex) {
    setMeta('meta[name="robots"]', 'name', 'robots', 'noindex, follow')
  } else if (existing) {
    existing.remove()
  }
}

/**
 * Keeps the tab title and description in sync with a view's data.
 * Accepts refs, getters-in-refs or plain strings.
 */
export function usePageMeta (title, description) {
  watchEffect(() => {
    applyPageMeta({ title: unref(title), description: unref(description) })
  })
}
